<template>
  <div>
    <b-col cols="12" sm="12">
      <div v-for="(rotation, index) in rotations" :key="index">
        <RotatingSubscription
          :rotation="rotation"
          :subscription="subscription"
          :vendor_uuid="vendor.uuid"
          @view-meals-selection-for-slot="(viewSub) => $emit('view-meals-selection-for-slot', viewSub)"
        />
      </div>
    </b-col>
  </div>
</template>

<script>
import moment from 'moment';

import { mapGetters } from 'vuex';
moment.locale('en-CA');

import {
  fetchSubscriptions
} from './rotating-subscription-service';
import RotatingSubscription from '@/subscriptions/rotating-subscription-partials/RotatingSubscription.vue';

export default {
  name: 'RotatingSubscriptions',
  components: { RotatingSubscription },
  props: {
    subscription: Object
  },
  data: () => {
    return {
      rotations: [],
    };
  },
  async created() {
    await this.fetchData();
  },
  computed: {
    ...mapGetters(['vendor', 'region'])
  },

  watch: {

  },
  mounted() {

  },
  methods: {
    async fetchData() {
      const {data, meta} = await fetchSubscriptions({
        regionUuid: this.region.uuid,
        vendorUuid: this.vendor.uuid
      });

      this.rotations = data;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../styles/variables.module';
@include inputs;
</style>